// src/pages/Leave/LeaveHolidayCalendar.jsx
import React from 'react';
import { Calendar as CalendarIcon } from 'lucide-react';
import HolCaldendar from '../HolydayCalendar/Calendar';

export default function LeaveHolidayCalendar() {
  return (
    <div className="min-h-full bg-gray-50 p-6">

      {/* Calendar Component */}
      <div className="rounded-xl border border-gray-200 bg-white shadow-sm overflow-hidden">
        <HolCaldendar />
      </div>
    </div>
  );
}